
import { Options, Vue } from "vue-class-component";
import { Article } from "@/typings/article";
import { Wrapper } from "@/typings/model";

@Options({
  components: {},
})
export default class Home extends Vue {
  interval: number = 5000;
  movieList = [];
  cpNewsList = [];
  enNewsList = [];
  partyList = [];
  bulletinList = [];
  projectsList: Article[] = [];
  bannerHeight = 0;
  bannerHeight2 = 0;
  equipmentList: Article[] = [];
  consultList: Article[] = [];
  linkList = [
    {
      url: "https://www.mee.gov.cn/",
      imgUrl: require("@/assets/images/friendshipLink/01.png"),
      title: "中华人民共和国生态环境部",
    },
    {
      url: "http://www.scies.org/",
      imgUrl: require("@/assets/images/friendshipLink/03.png"),
      title: "生态环境部华南环境科学研究所",
    },
    {
      url: "http://www.caepi.org.cn/",
      imgUrl: require("@/assets/images/friendshipLink/04.png"),
      title: "中国环境保护产业协会",
    },
    {
      url: "http://www.gdepi.com.cn/",
      imgUrl: require("@/assets/images/friendshipLink/05.png"),
      title: "广东环保产业网",
    },
    {
      url: "https://www.cenews.com.cn/",
      imgUrl: require("@/assets/images/friendshipLink/07.png"),
      title: "中国环境",
    },
  ];
  caseList = [];
  mounted() {
    this.getCpNews();
    this.getEnNews();
    this.getPartyList();
    this.getMovieList();
    this.getBulletinList();
    this.getProjects();
    this.getSource();
    this.getEquipmentList();
    this.handleHover();
    this.handleWrapper();
    this.imgLoad();
    this.imgLoad2();
    this.getCaseList();
    window.addEventListener(
      "resize",
      () => {
        if (this.$refs.bannerHeight) {
          const width = (this.$refs.bannerHeight as any)[0]?.width || 1;
          this.bannerHeight = (width * 16) / 23;
        }
        if (this.$refs.bannerHeight2) {
          this.bannerHeight2 =
            (this.$refs.bannerHeight2 as any)[0]?.height || 0;
        }
        this.imgLoad();
        this.imgLoad2();
      },
      false
    );
  }
  imgLoad() {
    this.$nextTick(() => {
      if (this.$refs.bannerHeight) {
        const width = (this.$refs.bannerHeight as any)[0]?.width || 1;
        this.bannerHeight = (width * 16) / 23;
      }
    });
  }
  imgLoad2() {
    this.$nextTick(() => {
      if (this.$refs.bannerHeight2) {
        this.bannerHeight2 = (this.$refs.bannerHeight2 as any)[0]?.height || 0;
      }
    });
  }
  handleHover() {
    setTimeout(() => {
      $(".el-tabs__header .el-tabs__item").on(
        "mouseover mouseenter",
        function (e) {
          $(this).trigger("click");
        }
      );
    });
  }
  handleWrapper() {
    $(".img-canvas img").on("click", function (e) {
      const video = $("#show_video")[0] as any;
      const videoSrc = $(this).attr("data-src") || "";
      const videoSrc1 = $("#show_video source").attr("src");

      const mask = $(".video-mask")
        .css("background-image")
        .replace('url("', "")
        .replace('")', "");

      if (videoSrc) {
        video.pause();
        $("#show_video").html(`<source src="${videoSrc}" type="video/mp4" />`);
        video.load();

        $(".video-mask").css({
          background: `url(${$(this).attr("src") || ""}) center no-repeat`,
          "background-size": "cover",
        });
        $(this)
          .attr("src", mask)
          .attr("data-src", videoSrc1 || "");
        $(".video-mask").show();
      }
    });
    $(".video-mask").on("click", function () {
      const video = $("#show_video")[0] as any;
      if (video.paused) {
        video.play().catch((error: any) => {
          console.error("Play request interrupted:", error);
        });
      } else {
        console.log("Media is already playing.");
      }
      $(this).hide();
    });
  }
  getMovieList() {
    (this as any).axios
      .get("/api/news/queryTopByPage", {
        params: { page: 1, pageSize: 5 },
      })
      .then((res: any) => {
        const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.movieList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/news/${item.dataFrom}/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getEnNews() {
    (this as any).axios
      .get("/api/news/enNews/queryByPage", {
        params: { page: 1, pageSize: 10, status: 1 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.enNewsList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/news/enNews/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
              top: item.top == 1 ? true : false,
            };
          });
        }
      });
  }
  getCpNews() {
    (this as any).axios
      .get("/api/news/cpNews/queryByPage", {
        params: { page: 1, pageSize: 10, status: 1 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.cpNewsList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/news/cpNews/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
              top: item.top == 1 ? true : false,
            };
          });
        }
      });
  }
  getPartyList() {
    (this as any).axios
      .get("/api/news/partyNews/queryByPage", {
        params: { page: 1, pageSize: 10, status: 1 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.partyList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/news/partyNews/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getBulletinList() {
    (this as any).axios
      .get("/api/news/bulletin/queryByPage", {
        params: { page: 1, pageSize: 10, status: 1 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.bulletinList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/news/bulletin/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getProjects() {
    (this as any).axios
      .get("/api/projects/queryTopByPage", {
        params: { page: 1, pageSize: 4 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.projectsList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/projects/${item.dataFrom}/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getEquipmentList() {
    (this as any).axios
      .get("/api/equipment/queryTopByPage", {
        params: { page: 1, pageSize: 4 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.equipmentList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/equipment/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getSource() {
    (this as any).axios
      .get("/api/consult/queryTopByPage", {
        params: { page: 1, pageSize: 4 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.consultList = data.map((item: any): Article => {
            return {
              id: item.id,
              title: item.title,
              url: `/consult/${item.dataFrom}/detail/${item.id}`,
              img: item.img,
              desc: item.desc,
              time: (item?.updatedAt || "").split(" ")[0],
            };
          });
        }
      });
  }
  getCaseList() {
    (this as any).axios
      .get("/api/case/queryTopByPage", {
        params: { page: 1, pageSize: 5 },
      })
      .then((res: any) => {
       const {status} = res
        const { data } = res.data;
        if (status == 200 && data) {
          this.caseList = data.map((item: any): Wrapper => {
            return {
              id: item.id,
              title: item.title,
              url: `/case/detail/${item.id}`,
              img: item.canvas,
            };
          });
        }
      });
  }
}
